import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "50",
  viewBox: "0 0 50 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M22.74 11.69h14.15c7.553 0 10.43 3.838 9.95 9.474-.718 9.232-6.353 14.388-13.787 14.388h-3.717c-1.08 0-1.68.72-2.038 2.517l-1.56 10.67c-.12.72-.48 1.08-.958 1.2h-8.873c-.84 0-1.08-.6-.96-2.04l5.396-34.17c.24-1.44.96-2.04 2.398-2.04z",
    fill: "#009de2"
  }), /*#__PURE__*/_jsx("path", {
    d: "M13.99-.06h14.147c3.957 0 8.633.12 11.87 2.88 2.158 1.797 3.237 4.795 2.997 8.032-.84 10.79-7.313 16.786-15.946 16.786h-6.954c-1.2 0-1.92.84-2.28 2.878l-2.037 12.35c-.12.84-.48 1.318-1.08 1.318h-8.63c-.96 0-1.32-.72-1.08-2.278L11.23 2.34c.12-1.68 1.08-2.4 2.76-2.4z",
    fill: "#113984"
  }), /*#__PURE__*/_jsx("path", {
    d: "M17.825 29.317l2.518-15.587c.24-1.32.96-2.04 2.398-2.04h14.15c2.28 0 4.198.36 5.637 1.08-1.44 9.593-7.674 14.868-15.707 14.868h-6.955c-.84 0-1.56.48-2.04 1.68z",
    fill: "#172c70"
  })]
});